import { render, staticRenderFns } from "./AttributeEditor.vue?vue&type=template&id=7949d81d&"
import script from "./AttributeEditor.vue?vue&type=script&lang=ts&"
export * from "./AttributeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AttributeEditor.vue?vue&type=style&index=0&id=7949d81d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports